module.exports = __webpack_public_path__ + "img/approval5.1c7a0257.png";